'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _sanitize_utility = require('../../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _ramda = require('ramda');

var _functional_utility = require('../../../../packages/common-utilities/src/functional_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TooltipComponent = function (_React$Component) {
  _inherits(TooltipComponent, _React$Component);

  function TooltipComponent(props) {
    _classCallCheck(this, TooltipComponent);

    var _this = _possibleConstructorReturn(this, (TooltipComponent.__proto__ || Object.getPrototypeOf(TooltipComponent)).call(this, props));

    _this.currentElement = null;
    _this.state = {
      tooltipStyle: 'none',
      tooltipTop: null,
      tooltipLeft: null,
      disclosure: null,
      alertText: null,
      arrowPosition: null,
      toolTipWidth: null,
      showCrossIcon: true,
      reduceRightPadding: false
    };

    _this.openTooltip = _this.openTooltip.bind(_this);
    _this.closeTooltip = _this.closeTooltip.bind(_this);
    _this.handleEscKey = _this.handleEscKey.bind(_this);
    _this.adjustTopPositionByReferrerTop = _this.adjustTopPositionByReferrerTop.bind(_this);
    return _this;
  }

  _createClass(TooltipComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.body.addEventListener('keydown', this.handleEscKey);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.removeEventListener('keydown', this.handleEscKey);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!(0, _ramda.isNil)(this.state.toolTipWidth) && !(0, _ramda.isNil)(this.state.jtfTopPosition)) {
        this.adjustTopPositionByReferrerTop();
      }
    }
  }, {
    key: 'adjustTopPositionByReferrerTop',
    value: function adjustTopPositionByReferrerTop() {
      var tooltipTop = this.state.tooltipTop;

      if (!(0, _ramda.isNil)(tooltipTop) && this.state.jtfTopPosition > tooltipTop) {
        var actDiffInTopPosition = this.state.jtfTopPosition - tooltipTop;

        var offset = 10;
        var toolTipsHeight = document.getElementsByClassName("headerTipContent")[0].clientHeight;
        var contentHeight = document.getElementsByClassName("fundAlertsubcont")[0].clientHeight;

        var expectedDiffInTopPosition = toolTipsHeight + offset;

        // The hint box is is two rows more than JTF but hint box only rendered one row
        if (actDiffInTopPosition > expectedDiffInTopPosition && toolTipsHeight > 0) {
          this.setState({ tooltipTop: tooltipTop + contentHeight });
        } else if (tooltipTop + toolTipsHeight > this.state.jtfTopPosition && toolTipsHeight > 0) {
          // The hint box is needs one more row as the content occupied two lines
          this.setState({ tooltipTop: tooltipTop - contentHeight / 2 });
        }
      }
    }
  }, {
    key: 'handleEscKey',
    value: function handleEscKey(event) {
      var keyCode = event.keyCode;
      if (keyCode === 27) {
        this.closeTooltip(event);
      }
    }
  }, {
    key: 'openTooltip',
    value: function openTooltip(position, disclosure, alertText) {
      var _this2 = this;

      var asHTML = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var event = arguments[4];

      this.currentElement = event ? event.currentTarget : null;
      this.setState({
        asHTML: asHTML,
        tooltipStyle: 'inline-block',
        tooltipTop: position.top,
        tooltipLeft: position.left,
        disclosure: disclosure,
        alertText: alertText,
        arrowPosition: position.arrowPosition,
        toolTipWidth: position.toolTipWidth,
        toolTipContentWidth: position.toolTipContentWidth,
        closeTipPosition: position.closeTipPosition,
        toolTipContentScroll: position.toolTipContentScroll,
        zIndex: position.zIndex,
        background: position.background,
        showCrossIcon: (0, _ramda.isNil)(position.showCrossIcon) ? true : position.showCrossIcon,
        reduceRightPadding: (0, _ramda.isNil)(position.reduceRightPadding) ? false : position.reduceRightPadding,
        jtfTopPosition: position.jtfTopPosition
      }, function () {
        if ((0, _ramda.is)(HTMLElement, _this2.currentElement) && (0, _ramda.is)(HTMLElement, document.getElementById("globalTooltip"))) {
          document.getElementById("globalTooltip").focus({
            preventScroll: true
          });
          document.getElementById("globalTooltip").style.outline = "none";
        }
      });
    }
  }, {
    key: 'closeTooltip',
    value: function closeTooltip() {
      var _this3 = this;

      if (this.state.tooltipStyle !== 'none') {
        this.setState({
          tooltipStyle: 'none'
        }, function () {
          if ((0, _ramda.is)(HTMLElement, _this3.currentElement)) {
            _this3.currentElement.focus();
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref;

      var disclosure = this.state.disclosure;

      if (_collection_utility.CollectionUtility.isArray(disclosure) && disclosure.length > 1) {
        disclosure = disclosure.join("<br/><br/>");
      }
      var prop = 'overflowY';
      var background = (0, _ramda.isNil)(this.state.background) ? null : this.state.background;

      var dataNotEmptyAndStateAsHTML = this.state.asHTML && !(0, _functional_utility.isDataEmpty)(this.state.alertText);
      return _react2.default.createElement(
        'div',
        { className: 'global-tooltip position-absolute',
          'data-testid': 'global-tooltip-popup',
          style: {
            display: this.state.tooltipStyle,
            top: this.state.tooltipTop,
            left: this.state.tooltipLeft,
            width: this.state.toolTipWidth,
            zIndex: this.state.zIndex
          } },
        this.props.breakpoint < 4 && _react2.default.createElement('div', { className: 'modal-backdrop', style: { display: this.state.tooltipStyle }, onClick: this.closeTooltip }),
        _react2.default.createElement(
          'div',
          { id: 'globalTooltip', role: 'dialog', 'aria-describedby': 'global-tooltip-header global-tooltip-content', tabIndex: '-1', style: _collection_utility.CollectionUtility.merge({ display: this.state.tooltipStyle, width: this.state.toolTipWidth, background: background }, this.props.breakpoint < 4 ? { position: "fixed", top: "35%" } : {}), className: 'headerTooltip disclaimer' },
          _react2.default.createElement(
            'div',
            { className: 'headerTipContent ' + (this.state.showCrossIcon === true ? 'withCloseButton' : ''), id: 'global-tooltip-header',
              style: (_ref = {}, _defineProperty(_ref, prop, this.state.toolTipContentScroll), _defineProperty(_ref, 'width', this.state.toolTipContentWidth), _ref) },
            !(0, _functional_utility.isDataEmpty)(disclosure) && _react2.default.createElement('div', { className: 'fundAlertsubcont', dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosure) } }),
            dataNotEmptyAndStateAsHTML && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('br', null),
              _react2.default.createElement('div', { className: 'fundAlertsubcont', id: 'global-tooltip-content',
                dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.state.alertText) } })
            ),
            this.dataNotEmptyAndHTMLInnerHTML && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'div',
                { className: 'fundAlertsubcont', id: 'global-tooltip-content' },
                this.state.alertText
              )
            )
          ),
          this.state.showCrossIcon === true && _react2.default.createElement(
            'button',
            { id: 'closeTip-global-tooltip', style: { left: this.state.closeTipPosition, background: background },
              'aria-label': 'Close',
              className: 'closeTip visible-outline-focus',
              onClick: this.closeTooltip },
            _react2.default.createElement('span', { className: 'crossImage' })
          )
        )
      );
    }
  }, {
    key: 'dataNotEmptyAndHTMLInnerHTML',
    get: function get() {
      return !this.state.asHTML && !(0, _functional_utility.isDataEmpty)(this.state.alertText);
    }
  }]);

  return TooltipComponent;
}(_react2.default.Component);

exports.default = TooltipComponent;